(function () {
    'use strict';
    $(document).ready(function () {
        $('.interactive-svg').on('click', function (e) {
            const $container = $(this);
            const $this = $(e.target);

            if ($this.hasClass('clickable-link')) {
                const href = $this.data('href');
                const link = $container.find('.mtw-links .mtw-link[data-id="' + href + '"]').data('target-link');

                if (link) {
                    document.location = link;
                }
            }
        });
    });
}(jQuery));